import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { ContractPreview } from '../../hooks/useContracts';
import DeliveryZoneContractsUpdateForm from '../../user/settingsDialog/DeliveryZoneContractsUpdateForm';
import DeliveryZoneSettings from '../../user/settingsDialog/DeliveryZoneSettings';

export interface DeliveryZoneUpsertDialogProps {
  open: boolean;
  onClose: () => void;
  deliveryZoneIndex?: number;
}

export default function DeliveryZoneUpsertDialog({ open, onClose, deliveryZoneIndex }: DeliveryZoneUpsertDialogProps): React.JSX.Element {
  const [deliveryZoneContracts, setDeliveryZoneContracts] = useState<ContractPreview[] | undefined>();
  const [updatedZoneId, setUpdatedZoneId] = useState<string>('');

  const onDeliveryZoneSettingsClose = (contracts: ContractPreview[], deliveryZoneId: string): void => {
    if (!contracts.length) {
      onClose();
    } else {
      setDeliveryZoneContracts(contracts);
      setUpdatedZoneId(deliveryZoneId);
    }
  };

  const onDeliveryZonesUpdate = (): void => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(): void => { /* noop */ }}
    >
      {
        !deliveryZoneContracts?.length
          ? (
            <DeliveryZoneSettings
              next={onClose}
              onUpdate={onDeliveryZoneSettingsClose}
              standAlone
              addNewZone={deliveryZoneIndex === undefined}
              indexZoneToModify={deliveryZoneIndex}
            />
          )
          : (
            <DeliveryZoneContractsUpdateForm
              contracts={deliveryZoneContracts}
              deliveryZoneId={updatedZoneId}
              onClose={onDeliveryZonesUpdate}
            />
          )
      }
    </Dialog>
  );
}
